import React, { useEffect, useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { Button } from "@mui/material";
import { Add, LocationOn } from "@material-ui/icons";
import { DataGrid } from "@mui/x-data-grid";
import firebase from "../firebase";
import { dataGridSx, palette } from "../theme";
import PageContainer from "../Components/UI/PageContainer";
import PageHeader from "../Components/UI/PageHeader";

export default function LocationsPage() {
  const history = useHistory();
  const signedIn = global.config.uid !== "";
  const [loading, setLoading] = useState(true);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (!signedIn) return;
    const db = firebase.firestore();
    const unsub = db
      .collection("Main")
      .doc(global.config.uid)
      .collection("Locations")
      .onSnapshot((snapshot) => {
        setLocations(
          snapshot.docs.map((doc) => ({
            id: doc.id,
            location: doc.data().Location,
            sessionSalary: doc.data().SessionSalary,
            groupSalary: doc.data().GroupSalary,
          }))
        );
        setLoading(false);
      });
    return unsub;
  }, [signedIn]);

  const columns = [
    {
      field: "location",
      headerName: "Location",
      flex: 1.5,
      minWidth: 220,
      renderCell: (params) => (
        <span style={{ display: "flex", alignItems: "center", gap: 10, fontWeight: 700 }}>
          <LocationOn style={{ color: palette.primary, fontSize: 20 }} />
          {params.value}
        </span>
      ),
    },
    {
      field: "sessionSalary",
      headerName: "Session Rate",
      flex: 1,
      minWidth: 130,
      valueFormatter: (params) => (params.value != null && params.value !== "" ? `$${params.value}` : ""),
    },
    {
      field: "groupSalary",
      headerName: "Group Rate",
      flex: 1,
      minWidth: 130,
      valueFormatter: (params) => (params.value != null && params.value !== "" ? `$${params.value}` : ""),
    },
  ];

  if (!signedIn) return <Redirect to="/" />;

  return (
    <PageContainer maxWidth={900}>
      <PageHeader
        title="Locations"
        subtitle="Schools and clinics where you see kids, with your rates"
        actions={
          <Button
            variant="contained"
            color="secondary"
            startIcon={<Add />}
            onClick={() => history.push("/locations-profile")}
          >
            Add Location
          </Button>
        }
      />

      <DataGrid
        autoHeight
        loading={loading}
        rows={locations}
        columns={columns}
        onRowClick={(params) => history.push("/locations-profile?locationID=" + params.id)}
        disableRowSelectionOnClick
        initialState={{ pagination: { paginationModel: { pageSize: 20 } } }}
        pageSizeOptions={[20]}
        localeText={{ noRowsLabel: "No locations yet — add a school or clinic" }}
        sx={dataGridSx}
      />
    </PageContainer>
  );
}
